import React from 'react';
import ErrorPage from './ErrorPage.jsx';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log error details to console in development
        if (process.env.NODE_ENV === 'development') {
            console.error('ErrorBoundary caught an error:', error);
            console.error('Error info:', errorInfo);
        }
        
        // Store error info in state
        this.setState({ errorInfo });
        
        // Optionally log error to monitoring service in production
        // if (process.env.NODE_ENV === 'production') {
        //     // Send to error reporting service like Sentry
        //     console.error('ErrorBoundary caught an error', error, errorInfo);
        // }
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <ErrorPage 
                    error={this.state.error} 
                    errorInfo={this.state.errorInfo}
                    onRetry={this.handleRetry}
                />
            );
        }
        
        return this.props.children;
    }
}

export default ErrorBoundary;


